import React, { useState, useMemo } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { api, extractErrorMessage } from "../../../../util/api";
import { snakifyKeys } from "../../../../util/helpers";
import { VisualForm } from "./VisualForm";

export const EditVisualModal = ({ completionScreenVisual, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (values) => {
    setError(null);
    const { completionScreenVisual, ...otherParams } = values;
    const params = { ...otherParams, completionScreenVisual: { bytes: completionScreenVisual } };

    try {
      const res = await api.patch(`/admin/submit_right_visual_managements/${params.id}`, snakifyKeys(params));

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  const initialValues = useMemo(
    () => ({
      ...completionScreenVisual,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(completionScreenVisual)]
  );

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit New Visual</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={initialValues}>
            {(props) => <VisualForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
